import { Skeleton } from '@robocorp/components';
import { styled } from '@robocorp/theme';

const StyledBox = styled.rect`
  transform: translateX(calc(2% + 32px));
`;

const CardSkeleton = () => (
  <Skeleton width="100%" height="242px">
    <rect x="2%" y="12" rx="3" ry="3" width="25%" height="16" />
    <rect x="2%" y="38" rx="3" ry="3" width="60%" height="18" />

    <rect x="8%" y="90" rx="3" ry="3" width="84%" height="28" />

    <rect x="2%" y="148" rx="3" ry="3" width="16" height="16" />
    <StyledBox x="2%" y="148" rx="3" ry="3" width="75%" height="16" />

    <rect x="2%" y="181" rx="3" ry="3" width="16" height="16" />
    <StyledBox x="2%" y="181" rx="3" ry="3" width="68%" height="16" />

    <rect x="2%" y="214" rx="3" ry="3" width="16" height="16" />
    <StyledBox x="2%" y="214" rx="3" ry="3" width="78%" height="16" />
  </Skeleton>
);

export default CardSkeleton;
